









































































































import Vue from "vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import InfoCard from "@/components/PrjOverview/InfoCard.vue";
import StatusCard from "@/components/PrjOverview/StatusCard.vue";
import UsageCard from "@/components/PrjOverview/UsageCard.vue";

export default Vue.extend({
  name: "PrjOverview",
  components: { InfoCard, StatusCard, UsageCard },
  data() {
    return {
      tabActive: "app",
      timeInterval: "1h",
      phyArr: [
        { name: "CPU", api: "namespace_cpu_usage" },
        { name: "内存(MB)", api: "namespace_memory_usage" },
        {
          name: "网络发送速率(bps)",
          api: "namespace_net_bytes_transmitted"
        },
        {
          name: "网络接收速率(bps)",
          api: "namespace_net_bytes_received"
        }
      ],
      appArr: [
        { name: "容器", icon: "icon-apps", api: "namespace_container_count" },
        { name: "服务", icon: "icon-fuwuqi", api: "namespace_service_count" },
        {
          name: "路由",
          icon: "icon-luyouguanli",
          api: "namespace_ingress_count"
        },
        { name: "任务", icon: "icon-vedioAI", api: "namespace_job_count" },
        {
          name: "容器组",
          icon: "icon-col_containers",
          api: "namespace_pod_count"
        },
        {
          name: "存储卷",
          icon: "icon-cunchujuan",
          api: "namespace_pvc_count"
        },
        {
          name: "无状态副本集",
          icon: "icon-bushu",
          api: "namespace_deployment_count"
        },
        {
          name: "有状态副本集",
          icon: "icon-fuben",
          api: "namespace_statefulset_count"
        }
      ]
    };
  },
  watch: {
    statusLoading(val: any) {
      if (!val) {
        // @ts-ignore
        this.$refs.statusCard?.setChart([
          this.stateful,
          this.deloyment,
          this.job,
          this.cronJob
        ]);
      }
    }
  },
  computed: {
    ...mapState("LoginInfo", ["userinfo", "project"]),
    ...mapGetters("LoginInfo", ["tenant"]),
    ...mapState("PrjOverview", [
      "appCount",
      "userCount",
      "pipelineCount",
      "infoLoading",
      "statusLoading",
      "usageLoading",
      "stateful",
      "deloyment",
      "job",
      "cronJob",
      "cpuUsage",
      "memoryUsage"
    ])
  },
  beforeDestroy() {
    this.clear();
  },
  mounted() {
    this.getInfo();
    this.getStatus();
    this.getUsage();
  },
  methods: {
    ...mapActions("PrjOverview", ["getInfo", "getStatus", "getUsage"]),
    ...mapMutations("PrjOverview", { clear: "CLEAR" }),
    select(tabActive: string) {
      this.tabActive = tabActive;
    }
  }
});
